.selector {
  display: flex;
  font-size: 0.875em;
}

.btn {
  composes: btnClean from '../utils.module.css';
  display: flex;
  align-items: center;
  padding: 0.125rem 1rem 0;
  border-bottom: 0.25rem solid transparent;
  line-height: 1;
  outline-offset: -1px;
  transition: border-color 0s ease-out;
}

.btn:hover,
.btn[aria-selected='true'] {
  transition-duration: 0.2s, 0.2s;
}

.btn:hover {
  border-bottom-color: var(--secondary-light);
}

.btn[aria-selected='true'] {
  border-bottom-color: var(--secondary);
  font-weight: 600;
}

.icon {
  width: 1.125em;
  height: 1.125em;
  margin-right: 0.5rem;
  margin-bottom: -0.0625em;
}
